import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const PartnerProductSearchTypeSchema = z
  .enum(['GOODS_NAME', 'GOODS_NO'])
  .describe('PartnerProductSearchTypeSchema');

export type PartnerProductSearchType = z.infer<typeof PartnerProductSearchTypeSchema>;

const GetPartnerBrandProductsSearchRequestSchema = z
  .object({
    brandId: z.string(),
    platform: z.string(),
    searchType: PartnerProductSearchTypeSchema,
    keyword: z.string().optional(),
    goodsNos: z.array(z.number()).optional(),
    page: z.number().int().min(1).optional(),
    size: z.number().int().min(1).max(30).optional(),
  })
  .describe('GetPartnerBrandProductsSearchRequestSchema');

export type GetPartnerBrandProductsSearchRequest = z.infer<
  typeof GetPartnerBrandProductsSearchRequestSchema
>;

const PartnerProductSchema = z
  .object({
    goodsNo: z.number(),
    goodsName: z.string(),
    category: z.string(),
    price: z.number(),
    imageUrl: z.string(),
    platform: z.string(),
    colorGroupId: z.number().nullable().optional(),
  })
  .describe('PartnerProductSchema');

export type PartnerProduct = z.infer<typeof PartnerProductSchema>;

const GetPartnerBrandProductsSearchResponseDataSchema = z
  .object({
    list: z.array(PartnerProductSchema),
  })
  .describe('GetPartnerBrandProductsSearchResponseDataSchema');

const GetPartnerBrandProductsSearchResponseSchema = createApiResponseSchema(
  GetPartnerBrandProductsSearchResponseDataSchema,
);

export type GetPartnerBrandProductsSearchResponse = z.infer<
  typeof GetPartnerBrandProductsSearchResponseSchema
>;

/** GET `/v1/partner/brands/{brandId}/products/search` — 브랜드 상품 검색 */
export const getPartnerBrandProductsSearch = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetPartnerBrandProductsSearchRequestSchema),
    async ({ brandId, ...query }: GetPartnerBrandProductsSearchRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetPartnerBrandProductsSearchResponse>(
          partnerApiPath.getBrandProductsSearch(brandId),
          query,
        ),
      ),
    validateApiResponse(GetPartnerBrandProductsSearchResponseSchema),
  ),
);
